import React, { forwardRef } from 'react';
interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
}
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(({
  className = '',
  error,
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-118">
        <textarea ref={ref} className={`
            block w-full rounded-lg border shadow-sm py-2.5 px-3 text-gray-900 placeholder:text-gray-400
            focus:ring-2 focus:ring-inset focus:ring-teal-600 sm:text-sm sm:leading-6
            ${error ? 'border-red-300 focus:ring-red-500' : 'border-gray-300 focus:border-teal-600'}
            ${className}
          `} {...props} data-id="element-119" />
        {error && <p className="mt-1 text-sm text-red-600" data-id="element-120">{error}</p>}
      </div>;
});
Textarea.displayName = 'Textarea';